function twoDigits(n) {
  const words = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen'
  ];
  return words[n] || String(n);
}

function tensWord(n) {
  const words = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  if (n < 20) return twoDigits(n);
  const t = Math.floor(n / 10);
  const o = n % 10;
  return `${words[t]}${o ? ` ${twoDigits(o)}` : ''}`.trim();
}

/** Converts 1–999 to words (hundreds, tens, ones). */
function upTo999ToWords(num) {
  if (num <= 0) return '';
  if (num < 100) return tensWord(num);
  const h = Math.floor(num / 100);
  const r = num % 100;
  return `${twoDigits(h)} Hundred${r ? ` ${tensWord(r)}` : ''}`.trim();
}

/** Converts 1–99,999 (below one lakh) using thousand + hundred chunks. */
function belowLakhToWords(remaining) {
  if (remaining <= 0) return '';
  const parts = [];
  const thousand = Math.floor(remaining / 1000);
  if (thousand > 0) {
    const tw = upTo999ToWords(thousand);
    if (tw) parts.push(`${tw} Thousand`);
    remaining %= 1000;
  }
  if (remaining > 0) {
    const rest = upTo999ToWords(remaining);
    if (rest) parts.push(rest);
  }
  return parts.join(' ');
}

/**
 * INR amount in words (Indian numbering: Crore, Lakh, Thousand).
 * @param {string|number} value
 * @returns {string} e.g. "₹ 2,50,000 — Two Lakh Fifty Thousand rupees only"
 */
export function amountInWordsInr(value) {
  const n = Number(String(value || '').replace(/,/g, ''));
  if (!Number.isFinite(n) || n < 1000) return '';

  let remaining = Math.floor(n);
  const parts = [];

  const crore = Math.floor(remaining / 10000000);
  if (crore > 0) {
    parts.push(`${upTo999ToWords(crore)} Crore`);
    remaining %= 10000000;
  }
  const lakh = Math.floor(remaining / 100000);
  if (lakh > 0) {
    parts.push(`${upTo999ToWords(lakh)} Lakh`);
    remaining %= 100000;
  }
  if (remaining > 0) {
    const tail = belowLakhToWords(remaining);
    if (tail) parts.push(tail);
  }

  const words = parts.join(' ').replace(/\s+/g, ' ').trim();
  return words ? `₹ ${n.toLocaleString('en-IN')} — ${words} rupees only` : '';
}

function inrAnnualHint(value, emptyLabel) {
  const raw = String(value ?? '').replace(/,/g, '').trim();
  if (!raw || !/^\d+$/.test(raw) || Number(raw) < 1000) {
    return emptyLabel;
  }
  const line = amountInWordsInr(raw);
  return line ? `${line} (per annum)` : emptyLabel;
}

/** Candidate / staff salary fields (6+ digits when validating CTC). */
export function salaryHintInr(value) {
  const raw = String(value ?? '').replace(/,/g, '').trim();
  if (!raw || !/^\d{6,}$/.test(raw)) {
    return 'Annual amount in INR (per annum)';
  }
  return inrAnnualHint(raw, 'Annual amount in INR (per annum)');
}

/** Job budget fields (any annual INR amount ≥ ₹1,000). */
export function budgetHintInr(value) {
  return inrAnnualHint(value, 'Annual budget in INR (per annum)');
}
